


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { sleep } from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component
export default class ShareModel extends Vue {
  @Prop() ActivityId
  close() {
    this.$emit('update:showFollow', false)
  }
  cancel() {
    window.localStorage.setItem('__ActivityId', this.ActivityId)
    this.$emit('update:showFollow', false)
  }
  async follow() {
    const self = this
    await sleep(1000)
    this.close()
    if (env.type === 'ivydad') {
      await env.jump(`mp://pages/follow/index?username=gh_e72fdc01f3d9`)
    } else {
      let { data } = await this.$axios.post('/api/mobile/h5/xcx/getXcxScheme', {
        disableAlert: true,
        path: 'pages/follow/index',
        appId: 'wxeb0d35f70ee65c3d',
      })
      if (data['Scheme']) {
        window.location.href = data['Scheme']
      }
    }
  }
}
